var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag-basic-icon",class:{ 'tag-basic-icon--box-shadow': _vm.boxShadow !== false },style:([
    _vm.styles,
    {
      '--tag-bg-color': _vm.backgroundColour,
      '--tag-text-color': _vm.textColour
    }
  ]),attrs:{"id":_vm.$attrs._id}},[_c('fa',{staticClass:"tag-basic-icon__icon",attrs:{"icon":['fad', _vm.faIcon]}}),_c('div',{staticClass:"tag-basic-icon__label",domProps:{"innerHTML":_vm._s(_vm.label[_vm.activeLanguage.code])}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }